module.exports = __webpack_public_path__ + "img/logo_new.bac6211d.png";